export default "__VITE_ASSET__BndvxrAH__"